import React from 'react'
import { Box } from '@mui/material'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import type { PlatformTourStop } from '../platformTourStops'
import { PlatformTourStopListItem } from './PlatformTourStopListItem'
import { tourListColumnSx, tourListHeadingSx, tourPlainListSx } from './platformTourStyles'

interface PlatformTourStopListProps {
  stops: PlatformTourStop[]
  stopIndex: number
}

/** The left column of the stop panel: every stop of the tour and how far they are. */
export const PlatformTourStopList: React.FC<PlatformTourStopListProps> = ({ stops, stopIndex }) => {
  const { t } = useTranslation()

  return (
    <Box sx={tourListColumnSx}>
      <Box sx={tourListHeadingSx}>{t('gamer.platformTour.yourTour')}</Box>
      <Box component="ol" sx={tourPlainListSx}>
        {stops.map((stop, index) => (
          <PlatformTourStopListItem
            key={stop.section}
            stop={stop}
            position={index + 1}
            currentPosition={stopIndex + 1}
          />
        ))}
      </Box>
    </Box>
  )
}
